import InlineLink from '@collab/atoms/InlineLink/InlineLink';

// Encoded to match md content.
const newTabForDeveloperTag = 'https://%7BdeveloperUrl%7D';

const InlineLinkMd: React.FC<{
  href: string;
  children: string | string[];
}> = ({ href, children }) => {
  const text = Array.isArray(children) ? children.join('') : children;
  const forceNewTab = href.includes(newTabForDeveloperTag) ? true : undefined;
  const replacedHref = href.replace(newTabForDeveloperTag, '');

  return (
    <InlineLink href={replacedHref} forceNewTab={forceNewTab}>
      {text}
    </InlineLink>
  );
};

export default InlineLinkMd;
